import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<app-loader></app-loader><router-outlet></router-outlet> ',
  standalone: false,
})
export class AppComponent {}
